import getPeople from './getPeople'

export default function (initialDataInteractor, personId) {
  let people = getPeople(initialDataInteractor);
  let foundPerson = null;

  people.forEach(function (person) {
    if (person.id == personId) {
      foundPerson = person;
    }
  });

  return foundPerson;
}